import { useI18n } from "../../lib/i18n";

/**
 * SCAFFOLD ONLY. Do NOT let an AI or the platform auto-fill the placeholders.
 * Each [OPERATOR: ...] block must be replaced with real, jurisdiction-specific
 * copy reviewed by the operator's counsel before this page is public-ready.
 */
const SECTIONS = [
  { id: "parties",   title: "1. Parties & Scope",              key: "parties" },
  { id: "eligibility", title: "2. Eligibility & Age",          key: "eligibility" },
  { id: "accounts",  title: "3. Accounts & Verification",      key: "accounts" },
  { id: "services",  title: "4. Description of the Service",   key: "services" },
  { id: "fees",      title: "5. Fees, Credits & Payouts",      key: "fees" },
  { id: "conduct",   title: "6. Acceptable Use",               key: "conduct" },
  { id: "ip",        title: "7. Intellectual Property",        key: "ip" },
  { id: "liability", title: "8. Limitation of Liability",      key: "liability" },
  { id: "termination", title: "9. Termination",                key: "termination" },
  { id: "law",       title: "10. Governing Law & Venue",       key: "law" },
  { id: "contact",   title: "11. Contact",                     key: "contact" },
];

export default function Terms() {
  const { t } = useI18n();
  return (
    <article className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">Legal</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-4" data-testid="legal-terms-title">{t("footer.terms")}</h1>
      <p className="text-xs text-[#F5B841] mb-10 font-mono uppercase tracking-widest" data-testid="legal-terms-scaffold-notice">Draft scaffold — operator must supply final copy</p>
      <div className="text-[#8B97AE] leading-relaxed space-y-8 text-sm">
        <p>{t("legal.placeholder")}</p>
        {SECTIONS.map((s) => (
          <section key={s.id} data-testid={`legal-terms-section-${s.key}`} className="border-l-2 border-white/10 pl-4">
            <h2 className="font-display text-lg font-bold text-[#E8ECF4] mb-2">{s.title}</h2>
            <p className="font-mono text-[10px] uppercase tracking-widest text-[#F5B841] mb-1">[OPERATOR: {s.key}]</p>
            <p>To be provided by the operator. This section will describe {s.title.toLowerCase().replace(/^\d+\.\s*/, "")}.</p>
          </section>
        ))}
        <p className="text-[10px] font-mono uppercase tracking-widest text-[#8B97AE] pt-8 border-t border-white/10" data-testid="legal-terms-effective-date">Effective date: [OPERATOR: date]</p>
      </div>
    </article>
  );
}
